import React from "react";

import CurrencyConvertor from "../../../../../global/currency-convertor";

import "./styles.css";
import { useParams } from "react-router-dom";

const PropertyMarkerMoblie = ({ property }) => {
  const { propertyId } = useParams();

  return (
    <div
      click-img-id={property.id}
      role="link"
      tabindex="-1"
      className="marker-effect-rain"
      style={{
        position: "relative",
      }}
    >
      <div class="price-tag main-price-tag">
        {property?.isLiked && (
          <span className="marker-heart">
            <svg viewBox="0 0 25 25" className="icon-heart" stroke="white" strokeWidth="3px">
              <path d="M23.3 5.076a6.582 6.582 0 0 0-10.446-1.71L12 4.147l-.827-.753a6.522 6.522 0 0 0-5.688-1.806A6.472 6.472 0 0 0 .7 5.075a6.4 6.4 0 0 0 1.21 7.469l9.373 9.656a1 1 0 0 0 1.434 0l9.36-9.638A6.414 6.414 0 0 0 23.3 5.076z"></path>
            </svg>
          </span>
        )}
        <CurrencyConvertor price={property.finalPrice} isShorthand={true} />
      </div>
      <div class="main-price-shadow price-svg-shadow">
        <svg viewBox="0 0 12 4" data-PropertyMarkerMoblieid="marker-shadow">
          <ellipse cx="6" cy="2" rx="6" ry="2"></ellipse>
        </svg>
      </div>
      {propertyId === property.id && (
        <div className="active-property-marker">
          <div className="active-property-pulsing"></div>
        </div>
      )}
    </div>
  );
};

export default PropertyMarkerMoblie;
